import config from '../../config';

export default function googleMapsService($window, $q) {
  'ngInject';

  const service = this;
  let scriptPromise = null;

  function initialize() {
    return $q((resolve) => {
      let script;
      if (!__TEST__) {
        const src = `//maps.google.com/maps/api/js?key=${config.GOOGLEMAPS_API_KEY}&callback=__googleMapsCallback&language=en`;
        script = document.createElement('script');
        script.src = src;
        script.onerror = () => resolve(null);
      }

      $window.__googleMapsCallback = function __googleMapsCallback() {
        service.maps = $window.google.maps;
        resolve(service.maps);
        delete $window.__googleMapsCallback;
      };

      if (!__TEST__) {
        document.head.appendChild(script);
      }
    });
  }

  if (__TEST__) {
    service.initialize = initialize;
  }

  service.load = function load() {
    if (scriptPromise) {
      return scriptPromise;
    }

    scriptPromise = (__TEST__ ? service.initialize : initialize)();

    scriptPromise.then(() => {
      service.loaded = true;
    });

    return scriptPromise;
  };
}
